import React, { createContext, useState, useContext } from 'react';
import { isAuthenticated as checkAuthStatus, loginUser as authLogin } from '../utils/auth';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Use a state variable to track authentication status reactively
  const [isAuthenticated, setIsAuthenticated] = useState(checkAuthStatus());

  const login = (token, id) => {
    authLogin(token, id); // Update localStorage via your utility
    setIsAuthenticated(true); // Update the React state, triggering re-render
  };

  const logout = () => {
    // You would need a logout function here too
    localStorage.removeItem('userToken');
    localStorage.removeItem('userId');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
